import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { useIntl, FormattedMessage } from 'react-intl'
import Price from 'components/shared/Price'
import SeparatedList from 'components/shared/SeparatedList'
import { useAppSelector } from 'store/hooks'
import { useResolutions } from 'store/resolutions'
import { useSortCardsByPerson } from 'store/unlimited-slice/hooks'
import { SummaryItem } from 'components/global/Summary/components/SummaryItem'
import steps from 'index'
import { useApp } from 'store/steps'
import SummaryShipmentOption from 'components/global/Summary/sections/SummaryShipmentOption'
import { useNavigate } from 'react-router-dom'
import { formatPrice } from 'helpers/helpers'
import { SummaryGiftCardsList } from 'components/global/Summary/sections/SummaryGiftCardsList'

const UnlimitedMobileSummary = () => {
    const { items, cart } = useAppSelector((state) => state.cart)
    const { stepIndex, appMode } = useApp()
    const { isTablet } = useResolutions()
    const { formatMessage } = useIntl()
    const navigateTo = useNavigate()

    const {
        totalPrice: cartTotalPrice,
        youSave,
        couponSimulationPrice,
        beforeDiscountPrice,
        payByCardPrice,
    } = cart || {}

    const shippingCost = items.shipping?.totalPrice
    const isCardOrderStep =
        steps[stepIndex].id === 'card_order' ||
        steps[stepIndex].id === 'renew_order'
    const isUnlimitedRenew = appMode === 'unlimited-renew'
    const cardsTotalPrice = (cartTotalPrice || 0) - (shippingCost || 0)
    const orderSumPrice = (cartTotalPrice ?? 0) - (payByCardPrice ?? 0)

    return (
        <>
            <Box direction="row" justify="space-between" mb={16}>
                <Text variant="heading5" color="secondary_500">
                    {formatMessage({
                        id: 'global.summary.section_caption_unlimited',
                        defaultMessage: 'Karta całoroczna',
                    })}
                </Text>
                <Text
                    as="button"
                    variant="body"
                    color="grayscale_700"
                    onClick={() => navigateTo('/')}
                >
                    {formatMessage({
                        id: 'global.btn.edit',
                        defaultMessage: 'Edytuj',
                    })}
                </Text>
            </Box>

            <SeparatedList gap={12} direction="column">
                {useSortCardsByPerson().map((card, index) => {
                    const {
                        description,
                        quantity,
                        unitPrice,
                        name,
                        cartItemId,
                        totalPrice,
                        totalPriceWithoutDiscount,
                        hasPromotion,
                    } = card

                    return (
                        <SummaryItem
                            key={`${cartItemId}${index}`}
                            name={name}
                            quantity={quantity}
                            description={description}
                            price={
                                // for unlimited renew process,
                                // instead of individual item price,
                                // use cart total price (differences in calculations)
                                // (there is always only one item in cart, although bundled)
                                isUnlimitedRenew && cardsTotalPrice
                                    ? cardsTotalPrice
                                    : unitPrice
                            }
                            totalPrice={totalPrice}
                            totalPriceWithoutDiscount={
                                // same case as above
                                isUnlimitedRenew && beforeDiscountPrice
                                    ? beforeDiscountPrice
                                    : totalPriceWithoutDiscount
                            }
                            hasPromotion={hasPromotion}
                        />
                    )
                })}
            </SeparatedList>
            <SummaryGiftCardsList />

            <SeparatedList gap={16} direction="column">
                {isCardOrderStep && (
                    <Box isFullWidth>
                        <Box
                            isFullWidth
                            direction="row"
                            justify="space-between"
                            mt={32}
                            mb={18}
                        >
                            <Text variant="heading5" color="secondary_500">
                                {formatMessage({
                                    id: 'global.summary.section_caption_shipment_method',
                                    defaultMessage: 'Sposób dostawy',
                                })}
                            </Text>
                        </Box>

                        <SummaryShipmentOption
                            shippingCost={shippingCost}
                            freeShippingType="park"
                        />
                    </Box>
                )}

                <Box isFullWidth mt={isCardOrderStep ? 0 : 32}>
                    <Box
                        isFullWidth
                        direction="row"
                        justify="space-between"
                        mb={4}
                    >
                        {/* < TODO: try to unify this part with creator mobile cart */}
                        <Box isFullWidth align="stretch" gap={8}>
                            <Box
                                direction="row"
                                align="flex-end"
                                justify="space-between"
                            >
                                <Text
                                    variant={isTablet ? 'body' : 'bodySmall'}
                                    color="secondary_500"
                                    mb={4}
                                >
                                    <FormattedMessage
                                        id="global.price.label_total_summary"
                                        defaultMessage="Do zapłaty"
                                    />
                                    :
                                </Text>
                                <Box align="flex-end">
                                    {!!beforeDiscountPrice &&
                                        beforeDiscountPrice > 0 && (
                                            <Price
                                                value={beforeDiscountPrice || 0}
                                                size="body"
                                                color="grayscale_700"
                                                crossedOutVariant="gray"
                                            />
                                        )}
                                    <Price
                                        value={orderSumPrice || 0}
                                        size="heading2"
                                    />
                                </Box>
                            </Box>

                            {!!couponSimulationPrice && !youSave && (
                                <Info
                                    color="success"
                                    hasSmallFont={true}
                                    hasIcon={false}
                                >
                                    <FormattedMessage
                                        id="global.msg.price_with_coupon"
                                        defaultMessage="Cena z kodem BLACKWEEKEND: {ammount} zł"
                                        values={{
                                            amount: formatPrice(
                                                couponSimulationPrice,
                                                false
                                            ),
                                        }}
                                    />
                                </Info>
                            )}
                        </Box>
                        {/* /> */}
                    </Box>
                </Box>
            </SeparatedList>
        </>
    )
}

export default UnlimitedMobileSummary
